import React from 'react'

import theme from 'theme'

import Text from './common/Text'
import TrackedExternalLink from './common/TrackedExternalLink'

interface FooterLinkProps {
  darkTheme?: boolean
  href?: string
}
const FooterLink: React.FC<FooterLinkProps> = (props) => (
  <TrackedExternalLink
    className="FooterLink"
    css={{
      fontWeight: theme.fontWeights[0],
      color: theme.colors.steel[1],
      '&:hover, &:focus': {
        color: theme.colors.blue[0]
      }
    }}
    {...props}
  />
)

const Footer: React.FC = () => (
  <footer
    css={{
      minHeight: 'var(--header-height)',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      background: theme.colors.panel[0],
      borderTop: theme.border.base,
      paddingTop: theme.space[3],
      paddingBottom: theme.space[3],
      paddingRight: theme.space[8] + theme.space[5] + theme.space[3], // Takes care of floating button
      paddingLeft: theme.space[4],

      [theme.mq[1]]: {
        flexDirection: 'row',
        alignItems: 'center'
      },

      [theme.mq[2]]: {
        paddingLeft: theme.space[7]
      }
    }}
  >
    <Text
      as="h4"
      css={{
        marginBottom: theme.space[1],
        color: theme.colors.steel[2],

        [theme.mq[1]]: {
          marginBottom: 0,
          marginRight: theme.space[2]
        }
      }}
    >
      &copy; {new Date().getFullYear()} Gremlin Inc.
    </Text>
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        margin: `-${theme.space[4]}px 0 0 -${theme.space[4]}px`,

        '.FooterLink': {
          marginTop: theme.space[4],
          marginLeft: theme.space[4]
        },

        [theme.mq[1]]: {
          marginLeft: 'auto'
        }
      }}
    >
      <FooterLink href="https://www.gremlin.com/blog/">Blog</FooterLink>
      <FooterLink href="https://www.gremlin.com/contact/">
        Contact Us
      </FooterLink>
    </div>
  </footer>
)

export default Footer
